    import { atom } from "recoil";
    import { recoilPersist } from "recoil-persist";

    // localStorage.clear(); //<- Soultone, est-ce que au lieu d'utiliser clear() vous pouvez utiliser removeItem() ? Ca risque d'enlever des trucs important dans le local storage.
    localStorage.removeItem('recoil-persist');//<- quelque chose comme ça
    
    const {persistAtom} = recoilPersist()

    export const freelanceBooking= atom({
        key: 'reservedWorkerId',
        effects_UNSTABLE: [persistAtom],
        default: undefined
    });

    
    export const stepsAtoms = atom({
        key: 'steps-atom',
        effects_UNSTABLE: [persistAtom],
        default:{
                step1: {
                    enterprise:{
                        societe: '',
                        nom_prenom: '',
                        nom:'',
                        prenom:'',
                        mail: '',
                        telephone:'',
                        pays:'',
                        countryCode:''
                    },
                    freelance:{
                        societe: '',
                        nom_prenom: '',
                        nom:'',
                        prenom:'',
                        mail: '',
                        telephone:'',
                        pays:''
                    },
                },
                step2: {
                    freelance:{
                        language: '',
                        tools: '',
                        description: 'top',
                        domaine_favoris:'',
                        domainInfo: [
                            {
                                name: "",
                                skills: [
                                    {
                                        skill: '',
                                        experience: '',
                                        durationType: 'an',
                                    },
                                ],
                            },
                        ],
                        file: {}
                    },
                    enterprise:[]
                },
                step3: {
                   numberOfTime: ''
                },
                step4: {
                    freelance:{
                        statut: '',
                        tarifMensuel: '',
                        currency: '€'
                    },
                    enterprise:{
                        fileName:'',
                        description:'',
                        fileObject:''
                    }
                },
                step5: {
                   freelance:{
                    username: '',
                    picture: {},
                   },
                   enterprise:{
                    username: '',
                    picture: {},
                   }
                },
                step6: {
                    freelance:{
                        date: '',
                        ville: '',
                    },
                    enterprise:{
                        function: '',
                        id_num: '',
                    }
                },
                step7: {
                    freelance:{
                        pays: '',
                        ville: '',
                    },
                    enterprise:{
                        id_doc_filename:'',
                        id_doc_file:null
                    }
                },
                step8: {},
                step9: {},
                step10: {},
        }
    })

